// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Buhta_models__Models from "../Models.js";
import * as Buhta_models__Validation from "../Validation.js";
import * as DateTime from "../../util/lib/DateTime.js";
import * as Decimal from "../../util/lib/Decimal.js";

const write_user_profile = Buhta_models__Models.IdentityProfile.write_t;

const read_user_profile = Buhta_models__Models.IdentityProfile.read_t;

const write_pagination = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "limit", t.limit),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "page", t.page),
                    tl: /* [] */0
                  }
                });
    });

const read_pagination = Atdgen_codec_decode.make(function (json) {
      return {
              limit: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("limit", Atdgen_codec_decode.$$int, param);
                    }), json),
              page: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("page", Atdgen_codec_decode.$$int, param);
                    }), json)
            };
    });

const write_org_profile = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "type", t.type_),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bin", t.bin),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "address", t.address),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_org_profile = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              type_: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("type", 0, Atdgen_codec_decode.$$int), json),
              bin: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("bin", "", Atdgen_codec_decode.string), json),
              name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("name", "", Atdgen_codec_decode.string), json),
              address: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("address", "", Atdgen_codec_decode.string), json)
            };
    });

function write__string_nullable(param) {
  return Atdgen_codec_encode.nullable(Atdgen_codec_encode.string, param);
}

function read__string_nullable(param) {
  return Atdgen_codec_decode.nullable(Atdgen_codec_decode.string, param);
}

const write_error = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "code", t.code),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write__string_nullable, "request", t.request),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "message", t.message),
                      tl: {
                        hd: Atdgen_codec_encode.field_o(undefined, Buhta_models__Validation.write_error_data, "data", t.data),
                        tl: /* [] */0
                      }
                    }
                  }
                });
    });

const read_error = Atdgen_codec_decode.make(function (json) {
      return {
              code: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("code", 400, Atdgen_codec_decode.$$int), json),
              request: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("request", undefined, read__string_nullable), json),
              message: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("message", Atdgen_codec_decode.string, param);
                    }), json),
              data: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("data", Buhta_models__Validation.read_error_data, param);
                    }), json)
            };
    });

const write_error_response = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, write_error, "error", t.error),
                  tl: /* [] */0
                });
    });

const read_error_response = Atdgen_codec_decode.make(function (json) {
      return {
              error: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("error", read_error, param);
                    }), json)
            };
    });

function write__x_ff3a8e7(param) {
  return Atdgen_codec_encode.contramap(Decimal.toString, Atdgen_codec_encode.string, param);
}

function read__x_ff3a8e7(param) {
  return Atdgen_codec_decode.map(Decimal.fromString, Atdgen_codec_decode.string, param);
}

function write__x_2dddd80(param) {
  return Atdgen_codec_encode.contramap(DateTime.toString, Atdgen_codec_encode.string, param);
}

function read__x_2dddd80(param) {
  return Atdgen_codec_decode.map(DateTime.fromString, Atdgen_codec_decode.string, param);
}

const write_crm_ticket_user = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "display_name", t.display_name),
                    tl: /* [] */0
                  }
                });
    });

const read_crm_ticket_user = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              display_name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("display_name", "", Atdgen_codec_decode.string), json)
            };
    });

const write_crm_ticket_action = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "type", t.type_),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "body", t.body),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, write_crm_ticket_user, "author", t.author),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, write__x_2dddd80, "created_at", t.created_at),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_crm_ticket_action = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              type_: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("type", "", Atdgen_codec_decode.string), json),
              body: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("body", "", Atdgen_codec_decode.string), json),
              author: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("author", read_crm_ticket_user, param);
                    }), json),
              created_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("created_at", read__x_2dddd80, param);
                    }), json)
            };
    });

function write__crm_ticket_action_list(param) {
  return Atdgen_codec_encode.list(write_crm_ticket_action, param);
}

function read__crm_ticket_action_list(param) {
  return Atdgen_codec_decode.list(read_crm_ticket_action, param);
}

const write_crm_ticket_detailed = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write_org_profile, "org", t.org),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write_crm_ticket_user, "answered", t.answered),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "status", t.status),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subject", t.subject),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "preview", t.preview),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, write__x_2dddd80, "created_at", t.created_at),
                              tl: {
                                hd: Atdgen_codec_encode.field_o(undefined, write__x_2dddd80, "updated_at", t.updated_at),
                                tl: {
                                  hd: Atdgen_codec_encode.field(undefined, write__crm_ticket_action_list, "actions", t.actions),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_crm_ticket_detailed = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              org: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("org", read_org_profile, param);
                    }), json),
              answered: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("answered", read_crm_ticket_user, param);
                    }), json),
              status: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("status", Atdgen_codec_decode.string, param);
                    }), json),
              subject: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("subject", "", Atdgen_codec_decode.string), json),
              preview: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("preview", "", Atdgen_codec_decode.string), json),
              created_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("created_at", read__x_2dddd80, param);
                    }), json),
              updated_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("updated_at", read__x_2dddd80, param);
                    }), json),
              actions: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("actions", read__crm_ticket_action_list, param);
                    }), json)
            };
    });

const write_crm_ticket = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write_org_profile, "org", t.org),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write_crm_ticket_user, "answered", t.answered),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "status", t.status),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subject", t.subject),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "preview", t.preview),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, write__x_2dddd80, "created_at", t.created_at),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, write__x_2dddd80, "updated_at", t.updated_at),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_crm_ticket = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              org: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("org", read_org_profile, param);
                    }), json),
              answered: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("answered", read_crm_ticket_user, param);
                    }), json),
              status: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("status", Atdgen_codec_decode.string, param);
                    }), json),
              subject: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("subject", "", Atdgen_codec_decode.string), json),
              preview: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("preview", "", Atdgen_codec_decode.string), json),
              created_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("created_at", read__x_2dddd80, param);
                    }), json),
              updated_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("updated_at", read__x_2dddd80, param);
                    }), json)
            };
    });

const write_crm_org_summary_user = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "email", t.email),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "phone", t.phone),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "first_name", t.first_name),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "last_name", t.last_name),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_crm_org_summary_user = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              email: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("email", "", Atdgen_codec_decode.string), json),
              phone: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("phone", "", Atdgen_codec_decode.string), json),
              first_name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("first_name", "", Atdgen_codec_decode.string), json),
              last_name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("last_name", "", Atdgen_codec_decode.string), json)
            };
    });

const write_crm_org_summary_tax = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "mode", t.mode),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "mode_text", t.mode_text),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.bool, "vat", t.vat),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "vat_number", t.vat_number),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "vat_series", t.vat_series),
                          tl: {
                            hd: Atdgen_codec_encode.field_o(undefined, write__x_2dddd80, "vat_given_at", t.vat_given_at),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_crm_org_summary_tax = Atdgen_codec_decode.make(function (json) {
      return {
              mode: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("mode", "", Atdgen_codec_decode.string), json),
              mode_text: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("mode_text", "", Atdgen_codec_decode.string), json),
              vat: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("vat", false, Atdgen_codec_decode.bool), json),
              vat_number: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("vat_number", "", Atdgen_codec_decode.string), json),
              vat_series: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("vat_series", "", Atdgen_codec_decode.string), json),
              vat_given_at: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("vat_given_at", read__x_2dddd80, param);
                    }), json)
            };
    });

const write_crm_org_summary_director = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "iin", t.iin),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "full_name", t.full_name),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "short_name", t.short_name),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "email", t.email),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "phone", t.phone),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_crm_org_summary_director = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              iin: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("iin", "", Atdgen_codec_decode.string), json),
              full_name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("full_name", "", Atdgen_codec_decode.string), json),
              short_name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("short_name", "", Atdgen_codec_decode.string), json),
              email: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("email", "", Atdgen_codec_decode.string), json),
              phone: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("phone", "", Atdgen_codec_decode.string), json)
            };
    });

const write_crm_org_summary_checking = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "currency", t.currency),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "iban", t.iban),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bik", t.bik),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bank", t.bank),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_crm_org_summary_checking = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              currency: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("currency", Atdgen_codec_decode.$$int, param);
                    }), json),
              iban: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("iban", Atdgen_codec_decode.string, param);
                    }), json),
              bik: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("bik", Atdgen_codec_decode.string, param);
                    }), json),
              bank: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("bank", Atdgen_codec_decode.string, param);
                    }), json)
            };
    });

function write__crm_org_summary_user_list(param) {
  return Atdgen_codec_encode.list(write_crm_org_summary_user, param);
}

function read__crm_org_summary_user_list(param) {
  return Atdgen_codec_decode.list(read_crm_org_summary_user, param);
}

const write_crm_org_summary = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, write_org_profile, "org", t.org),
                  tl: {
                    hd: Atdgen_codec_encode.field_o(undefined, write_crm_org_summary_tax, "tax", t.tax),
                    tl: {
                      hd: Atdgen_codec_encode.field_o(undefined, write_crm_org_summary_checking, "checking", t.checking),
                      tl: {
                        hd: Atdgen_codec_encode.field_o(undefined, write_crm_org_summary_director, "director", t.director),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, write__crm_org_summary_user_list, "organts", t.organts),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_crm_org_summary = Atdgen_codec_decode.make(function (json) {
      return {
              org: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("org", read_org_profile, param);
                    }), json),
              tax: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("tax", read_crm_org_summary_tax, param);
                    }), json),
              checking: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("checking", read_crm_org_summary_checking, param);
                    }), json),
              director: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("director", read_crm_org_summary_director, param);
                    }), json),
              organts: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("organts", /* [] */0, read__crm_org_summary_user_list), json)
            };
    });

const write_crm_filter_org = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.$$int, "type", t.type_),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "bin", t.bin),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "address", t.address),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_crm_filter_org = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.$$int, param);
                    }), json),
              type_: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("type", 0, Atdgen_codec_decode.$$int), json),
              bin: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("bin", "", Atdgen_codec_decode.string), json),
              name: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("name", "", Atdgen_codec_decode.string), json),
              address: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("address", "", Atdgen_codec_decode.string), json)
            };
    });

const write_crm__new_ticket_action = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "body", t.body),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "type", t.type_),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "subject", t.subject),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_crm__new_ticket_action = Atdgen_codec_decode.make(function (json) {
      return {
              body: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("body", "", Atdgen_codec_decode.string), json),
              type_: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("type", "", Atdgen_codec_decode.string), json),
              subject: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("subject", "", Atdgen_codec_decode.string), json)
            };
    });

function write__string_option(param) {
  return Atdgen_codec_encode.option_as_constr(Atdgen_codec_encode.string, param);
}

const read__string_option = Atdgen_codec_decode.option_as_constr(Atdgen_codec_decode.string);

const write_client_login_payload = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "csrfToken", t.csrfToken),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "challenge", t.challenge),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write__string_option, "error", t.error),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_client_login_payload = Atdgen_codec_decode.make(function (json) {
      return {
              csrfToken: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("csrfToken", "", Atdgen_codec_decode.string), json),
              challenge: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("challenge", "", Atdgen_codec_decode.string), json),
              error: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("error", undefined, read__string_option), json)
            };
    });

function write__string_list(param) {
  return Atdgen_codec_encode.list(Atdgen_codec_encode.string, param);
}

function read__string_list(param) {
  return Atdgen_codec_decode.list(Atdgen_codec_decode.string, param);
}

const write_client_consent_payload = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "csrfToken", t.csrfToken),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "challenge", t.challenge),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write__string_list, "requested_scope", t.requested_scope),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_client_consent_payload = Atdgen_codec_decode.make(function (json) {
      return {
              csrfToken: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("csrfToken", "", Atdgen_codec_decode.string), json),
              challenge: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("challenge", "", Atdgen_codec_decode.string), json),
              requested_scope: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("requested_scope", /* [] */0, read__string_list), json)
            };
    });

const write_cfg = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "app_url", t.app_url),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "idp_url", t.idp_url),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "cabinet_url", t.cabinet_url),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "grpc_url", t.grpc_url),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "cms_api_url", t.cms_api_url),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "app_env", t.app_env),
                            tl: {
                              hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "ym_key", t.ym_key),
                              tl: {
                                hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "app_mode", t.app_mode),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_cfg = Atdgen_codec_decode.make(function (json) {
      return {
              app_url: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("app_url", Atdgen_codec_decode.string, param);
                    }), json),
              idp_url: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("idp_url", Atdgen_codec_decode.string, param);
                    }), json),
              cabinet_url: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("cabinet_url", Atdgen_codec_decode.string, param);
                    }), json),
              grpc_url: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("grpc_url", Atdgen_codec_decode.string, param);
                    }), json),
              cms_api_url: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("cms_api_url", Atdgen_codec_decode.string, param);
                    }), json),
              app_env: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("app_env", Atdgen_codec_decode.string, param);
                    }), json),
              ym_key: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("ym_key", Atdgen_codec_decode.string, param);
                    }), json),
              app_mode: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("app_mode", Atdgen_codec_decode.string, param);
                    }), json)
            };
    });

const write_auth_login_payload = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "csrfToken", t.csrfToken),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "flowId", t.flowId),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "action", t.action),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, write__string_list, "errors", t.errors),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, write__string_list, "messages", t.messages),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    });

const read_auth_login_payload = Atdgen_codec_decode.make(function (json) {
      return {
              csrfToken: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("csrfToken", "", Atdgen_codec_decode.string), json),
              flowId: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("flowId", "", Atdgen_codec_decode.string), json),
              action: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("action", "", Atdgen_codec_decode.string), json),
              errors: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("errors", /* [] */0, read__string_list), json),
              messages: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("messages", /* [] */0, read__string_list), json)
            };
    });

const write_auth_error_payload = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "message", t.message),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "reason", t.reason),
                    tl: /* [] */0
                  }
                });
    });

const read_auth_error_payload = Atdgen_codec_decode.make(function (json) {
      return {
              message: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("message", "", Atdgen_codec_decode.string), json),
              reason: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("reason", "", Atdgen_codec_decode.string), json)
            };
    });

const write_app_payload = Atdgen_codec_encode.make(function (x) {
      const variant = x.NAME;
      if (variant === "ClientLoginPayload") {
        return Atdgen_codec_encode.constr1("ClientLoginPayload", write_client_login_payload, x.VAL);
      } else if (variant === "LogoutPayload") {
        return Atdgen_codec_encode.constr1("LogoutPayload", Atdgen_codec_encode.string, x.VAL);
      } else if (variant === "AuthErrorPayload") {
        return Atdgen_codec_encode.constr1("AuthErrorPayload", write_auth_error_payload, x.VAL);
      } else if (variant === "ClientConsentPayload") {
        return Atdgen_codec_encode.constr1("ClientConsentPayload", write_client_consent_payload, x.VAL);
      } else {
        return Atdgen_codec_encode.constr1("AuthLoginPayload", write_auth_login_payload, x.VAL);
      }
    });

const partial_arg_0 = [
  "ClientLoginPayload",
  {
    NAME: "Decode",
    VAL: (function (param) {
        return Atdgen_codec_decode.map((function (x) {
                      return {
                              NAME: "ClientLoginPayload",
                              VAL: x
                            };
                    }), read_client_login_payload, param);
      })
  }
];

const partial_arg_1 = {
  hd: [
    "AuthLoginPayload",
    {
      NAME: "Decode",
      VAL: (function (param) {
          return Atdgen_codec_decode.map((function (x) {
                        return {
                                NAME: "AuthLoginPayload",
                                VAL: x
                              };
                      }), read_auth_login_payload, param);
        })
    }
  ],
  tl: {
    hd: [
      "LogoutPayload",
      {
        NAME: "Decode",
        VAL: (function (param) {
            return Atdgen_codec_decode.map((function (x) {
                          return {
                                  NAME: "LogoutPayload",
                                  VAL: x
                                };
                        }), Atdgen_codec_decode.string, param);
          })
      }
    ],
    tl: {
      hd: [
        "ClientConsentPayload",
        {
          NAME: "Decode",
          VAL: (function (param) {
              return Atdgen_codec_decode.map((function (x) {
                            return {
                                    NAME: "ClientConsentPayload",
                                    VAL: x
                                  };
                          }), read_client_consent_payload, param);
            })
        }
      ],
      tl: {
        hd: [
          "AuthErrorPayload",
          {
            NAME: "Decode",
            VAL: (function (param) {
                return Atdgen_codec_decode.map((function (x) {
                              return {
                                      NAME: "AuthErrorPayload",
                                      VAL: x
                                    };
                            }), read_auth_error_payload, param);
              })
          }
        ],
        tl: /* [] */0
      }
    }
  }
};

const partial_arg = {
  hd: partial_arg_0,
  tl: partial_arg_1
};

function read_app_payload(param) {
  return Atdgen_codec_decode.$$enum(partial_arg, param);
}

Atdgen_codec_decode.option_as_constr(read_app_payload);

const write_app_state = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "ctx", t.ctx),
                  tl: {
                    hd: Atdgen_codec_encode.field_o(undefined, Atdgen_codec_encode.string, "serverUrl", t.serverUrl),
                    tl: {
                      hd: Atdgen_codec_encode.field_o(undefined, write_user_profile, "user", t.user),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.bool, "prefetched", t.prefetched),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "deviceType", t.deviceType),
                          tl: {
                            hd: Atdgen_codec_encode.field_o(undefined, write_app_payload, "payload", t.payload),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_app_state = Atdgen_codec_decode.make(function (json) {
      return {
              ctx: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("ctx", "user", Atdgen_codec_decode.string), json),
              serverUrl: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("serverUrl", Atdgen_codec_decode.string, param);
                    }), json),
              user: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("user", read_user_profile, param);
                    }), json),
              prefetched: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("prefetched", false, Atdgen_codec_decode.bool), json),
              deviceType: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("deviceType", "", Atdgen_codec_decode.string), json),
              payload: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("payload", read_app_payload, param);
                    }), json)
            };
    });

const write_apm = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "serviceName", t.serviceName),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "serviceVersion", t.serviceVersion),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "serverUrl", t.serverUrl),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "serverUrlPrefix", t.serverUrlPrefix),
                        tl: {
                          hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "environment", t.environment),
                          tl: {
                            hd: Atdgen_codec_encode.field(undefined, write__string_list, "distributedTracingOrigins", t.distributedTracingOrigins),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                });
    });

const read_apm = Atdgen_codec_decode.make(function (json) {
      return {
              serviceName: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("serviceName", Atdgen_codec_decode.string, param);
                    }), json),
              serviceVersion: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("serviceVersion", Atdgen_codec_decode.string, param);
                    }), json),
              serverUrl: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("serverUrl", "", Atdgen_codec_decode.string), json),
              serverUrlPrefix: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("serverUrlPrefix", "apm", Atdgen_codec_decode.string), json),
              environment: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("environment", "", Atdgen_codec_decode.string), json),
              distributedTracingOrigins: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("distributedTracingOrigins", /* [] */0, read__string_list), json)
            };
    });

const read_error_data = Buhta_models__Validation.read_error_data;

const write_error_data = Buhta_models__Validation.write_error_data;

const read_decimal = read__x_ff3a8e7;

const write_decimal = write__x_ff3a8e7;

const read_datetime = read__x_2dddd80;

const write_datetime = write__x_2dddd80;

export {
  read_user_profile ,
  write_user_profile ,
  read_pagination ,
  write_pagination ,
  read_org_profile ,
  write_org_profile ,
  read_error_data ,
  write_error_data ,
  read_error ,
  write_error ,
  read_error_response ,
  write_error_response ,
  read_decimal ,
  write_decimal ,
  read_datetime ,
  write_datetime ,
  read_crm_ticket_user ,
  write_crm_ticket_user ,
  read_crm_ticket_action ,
  write_crm_ticket_action ,
  read_crm_ticket_detailed ,
  write_crm_ticket_detailed ,
  read_crm_ticket ,
  write_crm_ticket ,
  read_crm_org_summary_user ,
  write_crm_org_summary_user ,
  read_crm_org_summary_tax ,
  write_crm_org_summary_tax ,
  read_crm_org_summary_director ,
  write_crm_org_summary_director ,
  read_crm_org_summary_checking ,
  write_crm_org_summary_checking ,
  read_crm_org_summary ,
  write_crm_org_summary ,
  read_crm_filter_org ,
  write_crm_filter_org ,
  read_crm__new_ticket_action ,
  write_crm__new_ticket_action ,
  read_client_login_payload ,
  write_client_login_payload ,
  read_client_consent_payload ,
  write_client_consent_payload ,
  read_cfg ,
  write_cfg ,
  read_auth_login_payload ,
  write_auth_login_payload ,
  read_auth_error_payload ,
  write_auth_error_payload ,
  read_app_payload ,
  write_app_payload ,
  read_app_state ,
  write_app_state ,
  read_apm ,
  write_apm ,
}
/* write_pagination Not a pure module */
